import { render, staticRenderFns } from "./onboard.vue?vue&type=template&id=64fcae40"
import script from "./onboard.vue?vue&type=script&lang=js"
export * from "./onboard.vue?vue&type=script&lang=js"
import style0 from "./onboard.vue?vue&type=style&index=0&id=64fcae40&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports